import React from "react";

import { Adapt } from "./products/Adapt";
import { LuxeAdapt } from "./products/LuxeAdapt";
import { LuxeBreeze } from "./products/LuxeBreeze";
import { LuxeBreezeSplit } from "./products/LuxeBreezeSplit";
import { ProAdapt } from "./products/ProAdapt";
import { ProBreeze } from "./products/ProBreeze";

/**
 * Per-product React component registry for ``ProductSpecificationsBlock``
 * (#33410). Keyed by the row's ``template_name`` (``content.lower()`` -- e.g.
 * ``"adapt"``, ``"luxebreezesplit"``), which is the legacy partial basename
 * (``cms/blocks/product-specifications/<template_name>.html``) and the ONLY
 * field that distinguishes ``luxebreeze`` from ``luxebreezesplit`` (both
 * collapse to the slug ``luxebreeze``).
 *
 * The dispatcher in ``ProductSpecificationsBlockTemplate`` looks the
 * ``template_name`` up here and renders the native component inside the
 * accordion panel, replacing the legacy server-rendered ``html``. A miss
 * renders ``null``.
 */
export const PRODUCT_COMPONENTS: Readonly<
    Partial<Record<string, () => React.JSX.Element>>
> = {
    adapt: Adapt,
    proadapt: ProAdapt,
    luxeadapt: LuxeAdapt,
    probreeze: ProBreeze,
    luxebreeze: LuxeBreeze,
    luxebreezesplit: LuxeBreezeSplit,
};
